export class UsuarioDTO {
	public ACTIVO: boolean;
	public ADMINISTRADOR: boolean;
	public ALIASDIRECTORIO: string;
	public APELLIDO: string;
	public CLAVE: string;
	public EMAIL: string;
	public IDOBRASOCIALTURNOS: string;
	public NOMBRE: string;
	public PADRESHABILITADOS: boolean;
	public USUARIO: string;
	public token: string;

	constructor() {}
}
